import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_index_view = _resolveComponent("index-view")!
  const _component_initial_view = _resolveComponent("initial-view")!
  const _component_login_view = _resolveComponent("login-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.acPage === 'index')
      ? (_openBlock(), _createBlock(_component_index_view, { key: 0 }))
      : _createCommentVNode("", true),
    ($data.acPage === 'initial')
      ? (_openBlock(), _createBlock(_component_initial_view, {
          key: 1,
          onOnSuccess: $options.onSuccessInitial
        }, null, 8, ["onOnSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_login_view, { ref: "login" }, null, 512)
  ], 64))
}